import type { SxProps, Theme } from "@mui/material";

export const activitiesLibraryPageLayoutSx: SxProps<Theme> = {
  width: "100%",
  px: 2,
  py: 0,
  /** Navigation Container (68px) and PageContentWrapper vertical padding (2rem + 1.5rem). */
  height: "calc(100vh - 68px - 3.5rem)",
  display: "flex",
  flexDirection: "column",
};

/** Matches layout Title / typography.Heading1 (PT Serif 32px/40px). */
export const activitiesLibraryPageHeadingSx: SxProps<Theme> = {
  flexShrink: 0,
  m: 0,
  mb: 1,
  fontFamily: '"PT Serif", sans-serif',
  fontSize: 32,
  lineHeight: "40px",
  fontWeight: 400,
};

export const activitiesLibraryPageHeaderSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 1,
  gap: 2,
};

export const activitiesLibraryPageCreateButtonSx: SxProps<Theme> = {
  fontWeight: 600,
  backgroundColor: "#171717",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#000",
  },
};

export const activitiesLibraryPageFiltersSx: SxProps<Theme> = {
  flexShrink: 0,
};

export const activitiesLibraryPageErrorAlertSx: SxProps<Theme> = {
  flexShrink: 0,
  mb: 2,
};

export const activitiesLibraryPageTableWrapSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  height: "100%",
};
